import api from '@/services/api'

export const updateLockUnlockExpectation = async (
    indicatorID,
    kpiCheckinID,
    indicatorType
) => {
    if (indicatorType == 'target') {
        return updateTargetLockUnlockExpectation(indicatorID, kpiCheckinID)
    } else if (indicatorType == 'kpi') {
        return updateKpiLockUnlockExpectation(indicatorID, kpiCheckinID)
    }
}

function updateTargetLockUnlockExpectation(indicatorID, kpiCheckinID) {
    return api.put(
        `/goals/${indicatorID}/checkins/lock-unlock-expectation/${kpiCheckinID}`
    )
}

function updateKpiLockUnlockExpectation(indicatorID, kpiCheckinID) {
    return api.put(
        `/kpi/${indicatorID}/checkins/lock-unlock-expectation/${kpiCheckinID}`
    )
}

export const getExpectancies = async (indicatorID, indicatorType) => {
    try {
        if (indicatorType == 'target') {
            return getTargetExpectations(indicatorID)
        } else if (indicatorType == 'kpi') {
            return getKpiExpectations(indicatorID)
        }
    } catch (e) {
        console.log(e)
    }
}

function getTargetExpectations(targetID) {
    return api.get(`goals/${targetID}/checkins/get-expectations`)
}

function getKpiExpectations(kpiID) {
    return api.get(`kpi/${kpiID}/checkins/get-expectations`)
}

export const updateExpectations = async (
    indicatorID,
    periodID,
    form,
    visualizationType,
    indicatorType
) => {
    try {
        if (indicatorType == 'target') {
            return updateTargetExpectations(
                indicatorID,
                periodID,
                form,
                visualizationType
            )
        } else if (indicatorType == 'kpi') {
            return updateKpiExpectations(
                indicatorID,
                periodID,
                form,
                visualizationType
            )
        }
    } catch (e) {
        console.log(e)
    }
}

function updateTargetExpectations(goalID, periodID, form, visualizationType) {
    return api.put(`goals/${goalID}/checkins/update-expectations`, {
        kpi_checkins: form,
        period_id: periodID,
        visualization_type: visualizationType,
    })
}

function updateKpiExpectations(kpiID, periodID, form, visualizationType) {
    return api.put(`kpi/${kpiID}/checkins/update-expectations`, {
        kpi_checkins: form,
        period_id: periodID,
        visualization_type: visualizationType,
    })
}

export const getPeriod = async periodID => {
    try {
        return api.get(`periods/${periodID}`)
    } catch (e) {
        console.log(e)
    }
}
